import { ComponentType } from 'src/formcontrols/hoc/PopupModal/ModalEnum';
import 'src/formcontrols/hoc/PopupModal/ModalFooter.css';
import * as ColorPalette from 'src/formcontrols/Themes/theme';
import React from 'react';

interface IProps {
  isComponentLoading: boolean;
  onCancelClicked: () => void;
  onOperatioConfirmed: () => any;
  componentType: ComponentType;
  footerText?: string;
  showOperationConfirmedBtn?: boolean;
}

const footerStyle = {
  background: ColorPalette.colors.bg,
  border: '0px',
  color: ColorPalette.colors.text,
};

const ModalFooter = (props: IProps) => {
  return (
    <div className="modal-footer" style={footerStyle}>
      {DisplayFooterText(props)}
      {props.showOperationConfirmedBtn === false ? '' : GetOperationButton(props)}
      {GetCancelButton(props)}
    </div>
  );
};

function DisplayFooterText(props: IProps) {
  if (props.componentType === ComponentType.SelectList) {
    return <label style={{ marginBottom: 0, marginRight: 'auto' }}>{props.footerText}</label>;
  } else if (props.footerText) {
    return <label style={{ marginBottom: 0, marginRight: 'auto' }}>{props.footerText}</label>;
  }
  return null;
}

function GetCancelButton(props: IProps) {
  if (
    !(
      props.componentType === ComponentType.Alert ||
      props.componentType === ComponentType.SelectList ||
      props.componentType === ComponentType.Information
    )
  ) {
    return (
      <button className="button button-cancel" onClick={props.onCancelClicked}>
        {props.componentType == ComponentType.Delete ? 'NO' : 'Cancel'}
      </button>
    );
  }
  return null;
}

function GetOperationButton(props: IProps) {
  if (!props.isComponentLoading) {
    switch (props.componentType) {
      case ComponentType.Delete:
        return (
          <button className="button button-delete" autoFocus={true} onClick={props.onOperatioConfirmed}>
            YES
          </button>
        );
      case ComponentType.Edit:
        return (
          <button className="button button-save" onClick={props.onOperatioConfirmed}>
            Save
          </button>
        );
      case ComponentType.SelectList:
      case ComponentType.Alert:
        return (
          <button className="button button-close" onClick={props.onOperatioConfirmed}>
            Ok
          </button>
        );
      case ComponentType.Search:
        return (
          <button className="button button-search" onClick={props.onOperatioConfirmed}>
            Search
          </button>
        );
      case ComponentType.Confirm:
        return (
          <button className="button button-confirm" onClick={props.onOperatioConfirmed}>
            Confirm
          </button>
        );
      case ComponentType.Information:
        return (
          <button className="button button-close" onClick={props.onOperatioConfirmed}>
            Close
          </button>
        );
    }
  }
  return null;
}

export default ModalFooter;
